import type { ManualTarget } from '@/shared/config/manual';

import { HelpLink } from '../help-link';

interface PageHeaderProps {
  title: string;
  description?: string;
  helpTarget?: ManualTarget | null;
  /** Shown beside the title on a wide screen, pinned to the right, under it on a narrow one. */
  children?: React.ReactNode;
}

export function PageHeader({ title, description, helpTarget, children }: PageHeaderProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
      <div>
        <div className="flex items-center gap-1">
          <h1 className="text-2xl font-semibold">{title}</h1>
          <HelpLink target={helpTarget} className="h-7 w-7" />
        </div>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {children && (
        <div className="w-full min-w-0 2xl:flex 2xl:w-auto 2xl:flex-1 2xl:justify-end">
          <div className="2xl:w-2/3">{children}</div>
        </div>
      )}
    </div>
  );
}
